import { testimonials } from '@/mocks/articles';

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-900 py-16 md:py-20" aria-labelledby="testimonial-heading">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium text-primary-500 uppercase tracking-wider whitespace-nowrap">
              瓜友口碑
            </span>
          </div>
          <h2
            id="testimonial-heading"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 mb-3"
          >
            吃瓜群众
            <br />
            怎么说
          </h2>
          <p className="text-base text-foreground-600 max-w-lg mx-auto">
            百万瓜友的选择，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, index) => (
            <article
              key={index}
              className={`bg-background-50 rounded-xl p-6 md:p-7 ${
                index === testimonials.length - 1 ? 'opacity-50' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-400'}`}
                  ></i>
                ))}
              </div>
              <h4 className="text-base font-bold text-foreground-50 mb-3">{t.name}</h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">{t.content}</p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-50">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}